export const Props = () => ({
  //--------------------------------------------------------------------------
  //                    Какой тег использовать для изображения
  //--------------------------------------------------------------------------
  tag:{
    type: String,
    default: 'img',
    required: false,
    validator: (value) => {
      const allowedTypes = ['img', 'object'];
      if(allowedTypes.includes(value)){
        return true;
      } else{
        throw new Error(`Параметр 'tag' в компоненте AvatarImage может содержать только значения: ${allowedTypes.join(', ')}`);
      }
    }
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
      
  //--------------------------------------------------------------------------
  //                     Ссылка на источник картинки
  //--------------------------------------------------------------------------
  src: {
    type: String,
    required: false,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //--------------------------------------------------------------------------
  //                         Подпись изображения
  //--------------------------------------------------------------------------
  alt: {
    type: String,
    default: 'Image',
    required: false,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx


  //--------------------------------------------------------------------------
  //                               Размер картинки
  //--------------------------------------------------------------------------
  size: {
    type: Number,
    default: 32,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx


  //--------------------------------------------------------------------------
  //                          Блюр картинки (размытость)
  //--------------------------------------------------------------------------
  blur: {
    type: Boolean,
    default: false,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx


  //--------------------------------------------------------------------------
  //                            Закругление картинки
  //--------------------------------------------------------------------------
  radius: {
    type: String,
    required: false,
    default: '50%',
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});
